import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, switchMap } from 'rxjs';
import {
	App,
	AppSettingsResponse,
	deserializeAppSettings,
	ENVIRONMENT,
	Environment,
	HttpsParamsBuilderNew,
	serializeAppSettingsCreate,
	serializeAppSettingsUpdate,
} from '@agilox/common';
import { Document } from 'jsonapi-typescript';

@Injectable({
	providedIn: 'root',
})
export class UserAppSettingsClient {
	private http = inject(HttpClient);
	private environment = inject<Environment>(ENVIRONMENT);

	getCurrent(app: App, userId: string): Observable<AppSettingsResponse | null> {
		const url = `${this.environment.serverNew}/user/v1/app-settings`;
		const params = HttpsParamsBuilderNew.buildParameters({
			filter: {
				app: app,
				'user.id': userId,
			},
		});

		return this.http.get<Document>(url, { params }).pipe(
			switchMap((response) => deserializeAppSettings(response)),
			catchError((error) => {
				return of(null);
			})
		);
	}

	create(app: App, userId: string, settings: unknown): Observable<AppSettingsResponse> {
		const url = `${this.environment.serverNew}/user/v1/app-settings`;
		const payload = serializeAppSettingsCreate(app, userId, settings);

		return this.http.post<Document>(url, payload).pipe(
			switchMap((response) => deserializeAppSettings(response)),
			switchMap((result) => {
				if (!result) {
					throw new Error('Failed to create app settings: empty response');
				}
				return of(result);
			})
		);
	}

	update(id: string, settings: unknown): Observable<Document> {
		const url = `${this.environment.serverNew}/user/v1/app-settings/${id}`;
		const payload = serializeAppSettingsUpdate(id, settings);

		return this.http.patch<Document>(url, payload);
	}
}
